// What a family can use, by plan (owner decision 2026-10-22):
//   trial    — 7 days from account creation: every exam, and in Learn one unit per year level per subject (the
//              first unit of each list). When the 7 days end, everything locks until they subscribe.
//   exam     — Exam Only: every exam (practice, section tests, mocks, writing), no lessons.
//   premium  — exams + every lesson.
//   family   — premium for up to 3 children (profiles).
// Paid plans written by the server before this change are mapped: the NAPLAN/Selective plans to Exam Only,
// All Access to Premium. Owner access (reserved for a future server-checked account role; never granted from the browser) unlocks everything.

export const TRIAL_DAYS = 7;
const DAY = 864e5;

export const PLAN_FEATURES = {
  exam: { exams: true, learn: 'none', profiles: 1 },
  premium: { exams: true, learn: 'all', profiles: 1 },
  family: { exams: true, learn: 'all', profiles: 3 },
};
const LEGACY = { essential: 'exam', plus: 'exam', selective: 'exam', allaccess: 'premium' };
export const normalisePlan = (plan) => LEGACY[plan] || plan;

/** Trial window from the account's creation time. */
export function trialState(createdAt, now = Date.now()) {
  const start = createdAt ? new Date(createdAt).getTime() : NaN;
  if (!Number.isFinite(start)) return { known: false, active: false, daysLeft: 0, endsAt: null };
  const endsAt = start + TRIAL_DAYS * DAY;
  const left = endsAt - now;
  return { known: true, active: left > 0, daysLeft: left > 0 ? Math.ceil(left / DAY) : 0, endsAt };
}

/**
 * Everything the app needs to decide what to lock.
 * plan: the account's plan ('trial' or a paid plan); createdAt: when the account was made; owner: server-checked owner role (currently always false).
 * Returns { tier, paid, exams, learn: 'all' | 'sample' | 'none', profiles, trial }.
 */
export function entitlements({ plan, createdAt, owner = false, now = Date.now() } = {}) {
  const trial = trialState(createdAt, now);
  if (owner) return { tier: 'owner', paid: true, exams: true, learn: 'all', profiles: 3, trial };
  const p = normalisePlan(plan);
  if (PLAN_FEATURES[p]) return { tier: p, paid: true, ...PLAN_FEATURES[p], trial };
  // not paid: the trial while it lasts. An account whose start we can't read yet (still loading) gets the trial,
  // so a slow network never locks a family out on their first visit.
  if (trial.active || !trial.known) return { tier: 'trial', paid: false, exams: true, learn: 'sample', profiles: 1, trial };
  return { tier: 'expired', paid: false, exams: false, learn: 'none', profiles: 1, trial };
}

/** In Learn, is this unit open? The sample is the first unit of each list (year level x subject). */
export const unitOpen = (ent, index) => ent.learn === 'all' || (ent.learn === 'sample' && index === 0);
